import React, {useState} from "react";
import { Menu, MenuItem, Grid, Button } from "@mui/material";
import { fetchDownloadFile } from "../../util/FileUtils";
import { getBuyerSpaceUsageGroupSummaryUrl } from "../../requests/reports/space-usage/buyer-space-usage-requests";
import { getSupplierSpaceUsageGroupSummaryReportUrl } from "../../requests/reports/space-usage/supplier-space-usage-requests";
import DownloadCsvIcon from "../icons/DownloadCsvIcon";
import {getErrorMessageForFileDownloads} from "../../util/NetworkErrorUtil";
import {withSnackbar} from "../hocs/withSnackbar";

export const groupByOptions = Object.freeze({
    BUYER: "BUYER",
    SUPPLIER: "SUPPLIER",
    LOCATION: "LOCATION",
    NONE: "NONE"
  });

const DownloadSpaceUsageCSVButton = ({query, onError, isBuyer, snackbarShowMessage}) => {
    const [menuAnchorEl, setMenuAnchorEl] = useState();

    const menuOpen = Boolean(menuAnchorEl);

    const handleClickMenuButton = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setMenuAnchorEl(null);
    };

    const handleExportByGroup = async (group) => {
        if(query && group) {
            let newQuery = Object.assign({}, query);
            newQuery.groupBy = group;
    
            if (isBuyer) {
                downloadFile(getBuyerSpaceUsageGroupSummaryUrl(newQuery))
            } else {
                downloadFile(getSupplierSpaceUsageGroupSummaryReportUrl(newQuery))
            }
        }

    }

    const handleError = (error) => {
        if (onError) {
            onError(error);
        } else {
            snackbarShowMessage(getErrorMessageForFileDownloads(error), 'error');
        }
    };

    const downloadFile = async (reportUrl) => {
        fetchDownloadFile(reportUrl, null, handleError);
    };

    return (
        <Grid item>
            <Grid item>
                <Button variant={"contained"} startIcon={<DownloadCsvIcon/>} onClick={handleClickMenuButton}>Export Group Summaries</Button>
            </Grid>
            <Menu open={menuOpen} anchorEl={menuAnchorEl} onClose={handleCloseMenu}>
                {
                    isBuyer ?
                        <MenuItem onClick={() => handleExportByGroup(groupByOptions.SUPPLIER)}>
                            Group By Supplier
                        </MenuItem>
                    :
                        <MenuItem onClick={() => handleExportByGroup(groupByOptions.BUYER)}>
                            Group By Buyer
                        </MenuItem>
                }
                <MenuItem onClick={() => handleExportByGroup(groupByOptions.LOCATION)}>
                    Group By Location
                </MenuItem>
            </Menu>
        </Grid>
            )
}

export default withSnackbar(DownloadSpaceUsageCSVButton);